import _ from 'lodash';

import createModel, { prop } from './lib/create_model';

/**
 * Local, non-persisted UI state describing how the conversation timeline is
 * currently filtered. `hiddenTypeGroups` lists the type-group keys (see
 * conversation_item_type_groups) the agent has chosen to hide; an empty list
 * means every type is shown. `address` is a normalized endpoint address
 * (lowercased email or normalized phone number); an empty string means items
 * are not filtered by address.
 */
const ConversationHistoryFilter = createModel({
  modelName: 'ConversationHistoryFilter',
  properties: {
    hiddenTypeGroups: prop([String]).default([]),
    address: prop(String).default(''),
  },

  isActive() {
    return this.hiddenTypeGroups.length > 0 || !!this.address;
  },

  isTypeGroupHidden(groupKey) {
    return _.includes(this.hiddenTypeGroups, groupKey);
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default ConversationHistoryFilter;
